import { EToySessionState, type TActuatorKey, TLastStop } from "@api/toys";

import { ECause } from "@services/webSocket/types";

export const actuatorIDMap: Partial<Record<string, TActuatorKey>> = {
	handy: "stroke",
};

export const toyPresetDescriptionMap: Partial<Record<string, string>> = {
	sensual: "Natural motion",
	teasing: "Slow and sensitive",
	deepthroat: "Intense and full-depth",
	"the peak": "Fast and powerful",
};

export const toyMessageTitleMap = {
	[ECause.CREATED]: `The user’s sex toy is ready to use`,
	[ECause.ACCEPTED]: `The user’s sex toy control is active`,
	[ECause.REVOKED]: `The user’s sex toy control is not active`,
	[ECause.OFFLINE]: `The user’s sex toy control is not active`,
};

export const toyMessageDescriptionMap = {
	[ECause.CREATED]: `This user has a sex toy available for your control! Ask him to let you play with it!`,
	[ECause.ACCEPTED]: `You've taken control of the user's sex toy. You can launch it at any time.`,
	[ECause.REVOKED]: `Control of the user's sex toy has ended. You can continue the private show without toy control.`,
	[ECause.OFFLINE]: `Control of the user's sex toy has ended. You can continue the private show without toy control.`,
};

export enum EProviderName {
	HANDY = "Handy",
	AUTOBLOW = "Autoblow",
}

export const TOYS_CONTROL_ENDED_MESSAGE = "The user has revoked control.";
export const TOYS_CONTROL_ENDED_HINT = "You can ask them to give it to you again.";
export const TOYS_OFFLINE_MESSAGE = "The user's device is offline.";
export const TOYS_OFFLINE_HINT = "Control resumes once they're back online.";

export const deviceTextStatusMap = (sessionState: EToySessionState, lastStop?: TLastStop | null) => {
	switch (sessionState) {
		case EToySessionState.GRANTED_STOPPED:
			return lastStop?.by ? "paused" : "not started";
		case EToySessionState.GRANTED_RUNNING:
			return "active";
		case EToySessionState.IDLE:
		case EToySessionState.PENDING:
			return "stopped by user";
		case EToySessionState.SUSPENDED_OFFLINE:
			return "user's device is offline";
		case EToySessionState.CLOSED:
		default:
			return "service not available";
	}
};

export const deviceTextStatusColorMap = (sessionState: EToySessionState, lastStop?: TLastStop | null) => {
	switch (sessionState) {
		case EToySessionState.GRANTED_STOPPED:
			return lastStop?.by ? "text-[#EED16B]" : "text-secondary";
		case EToySessionState.GRANTED_RUNNING:
			return "text-green-500";
		case EToySessionState.IDLE:
		case EToySessionState.PENDING:
			return "text-error-400";
		case EToySessionState.SUSPENDED_OFFLINE:
			return "text-error-400";
		case EToySessionState.CLOSED:
		default:
			return "text-grey-tertiary";
	}
};

export const deviceStatusTextDescriptionMap = (sessionState: EToySessionState, lastStop?: TLastStop | null) => {
	switch (sessionState) {
		case EToySessionState.GRANTED_STOPPED:
			return lastStop?.by
				? "You've paused control of the user's interactive toy. You can resume at any time by pressing Start."
				: "You've been given control of the user's interactive toy. Press Start to begin.";
		case EToySessionState.GRANTED_RUNNING:
			return `You are controlling the user's sex toy. Adjust intensity and patterns carefully. The user feels every move.`;
		case EToySessionState.IDLE:
		case EToySessionState.PENDING:
			return "Control has ended. The user has revoked control. You can ask them to give it to you again.";
		case EToySessionState.SUSPENDED_OFFLINE:
			return "The user's device is offline. Control resumes once they're back online.";
		case EToySessionState.CLOSED:
		default:
			return "The interactive toy control service is currently unavailable. Please try again later.";
	}
};
